
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mieten/produkt/[slug]",
      function () {
        return require("private-next-pages/mieten/produkt/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/mieten/produkt/[slug]"])
      });
    }
  